import { partytownSnippet } from '@builder.io/partytown/integration';

(function(document) {
    let script = document.createElement('script');
    script.innerHTML = partytownSnippet()
    document.querySelector('head').appendChild(script);
})(document)